// Constants
import { PAYMENT_METHODS_CODES } from "constants/paymentMethodsConst";
import { CurrencyType } from "./Currency";

export enum TRANSACTION_STATUS {
  SUCCESS = "success",
  ERROR = "error",
  CANCELED = "canceled",
  PENDING = "pending",
  REJECTED = "rejected",
  REQUEST = "request",
}

export type TransactionType = {
  id: string;
  remoteId: string;
  amount: number;
  status: TRANSACTION_STATUS;
  createdAt: string;
  updatedAt: string;
  currency: CurrencyType;
  type: string;
  method: MethodType;
  system: SystemTransactionType;
  userId: number;
  currencyIsoCode: string;
  paymentSystemId: number;
  paymentSystemName: string;
  paymentMethodCode: PAYMENT_METHODS_CODES;
  activatedAt: string;
};

export type TransactionResponseType = {
  statusCode: number;
  items: TransactionType[];
};

export type Transaction = {
  type: string;
};

export type TransactionPaymentMethod = {
  icon: JSX.Element;
  title: string;
};

export type TransactionSortType = {
  id: number;
  title: string;
  option: number;
};

export enum TRANSACTION_SORT_ENUMS {
  ALL,
  BONUS,
  PAYMENT,
  REFERRAL,
  MANUAL,
}

export type MethodType = {
  id: number;
  name: string;
  code: PAYMENT_METHODS_CODES;
  createdAt: string;
  updatedAt: string;
  logo: string;
};

export enum TRANSACTION_NAME {
  ALL = "All",
  PAYMENT = "Payment",
  REFERRAL = "Referral",
  BONUS = "Bonus",
  MANUAL = "Manual",
}

export type SystemTransactionType = {
  id: number;
  name: string;
  createdAt: Date;
  updatedAt: Date;
};
